import * as tslib_1 from "tslib";
import { ItemContainer } from './item_container';
var FormGroup = /** @class */ (function (_super) {
    tslib_1.__extends(FormGroup, _super);
    function FormGroup(param) {
        return _super.call(this, param) || this;
    }
    FormGroup.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "FormGroup" });
    };
    FormGroup.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return FormGroup;
}(ItemContainer));
export { FormGroup };
//# sourceMappingURL=form_group.js.map